import React from 'react';
import { useParams } from 'react-router';

import { ContactDetailsTasks } from '@/views/contactsDetails/components/tasks/ContactDetailsTasks.comp.tsx';

export const ContactDetailsTasksTab: React.FC = () => {
  const { contactId } = useParams();

  if (!contactId) {
    return null;
  }

  return <ContactDetailsTasks contactId={Number.parseInt(contactId)} />;
};
